{
  "additional_products": "Zusätzliche Produkte",
  "apply": "Anwenden",
  "arriving_at": "Ankunftsort",
  "available": "Verfügbar",
  "available_for_single_use": "Buchbar zur Alleinnutzung",
  "back": "Zurück",
  "back_to_payment": "Zurück zur Bezahlung",
  "book_now": "Jetzt buchen",
  "booking_confirmed_text": "Ihre Buchung ist bestätigt.",
  "booking_confirmed_title": "Vielen Dank für Ihre Buchung bei uns!",
  "cabin_count": "{{ count }} Kabinen",
  "cabin_count_one": "{{ count }} Kabine",
  "cabin_count_zero": "Auswählen",
  "cabin_x": "Kabine {{ index }}",
  "chat_button_text": "💬 Wie können wir helfen?",
  "checkout": "Bezahlung",
  "choose_preferred_ship": "Wählen Sie Ihr bevorzugtes Schiff",
  "choose_preferred_ship_one": "Schiff",
  "choose_preferred_ship_other": "Gewünschtes Schiff auswählen",
  "choose_ship": "Schiff auswählen",
  "chosen_ship": "Ausgewähltes Schiff",
  "close": "Schließen",
  "creating_your_booking": "Ihre Buchung wird bearbeitet",
  "credit_card_extra_charge": "Für Kreditkarten außerhalb der EU wird eine Transaktionsgebühr von 3% erhoben.",
  "current_voucher_code": "Code: {{ code}}",
  "date_format": "DD.MM.YYYY",
  "date_format_short": "D MMM",
  "date_range": "{{ start }} bis {{ end }}",
  "depart_from": "Abfahrtsort",
  "departure_date": "Abfahrtsdatum",
  "discount": "Rabatt",
  "discount_tooltip": "Wenn ein Datum orange hervorgehoben ist, bedeutet dies, dass für die Tour, die an dem betreffenden Tag beginnt, ein Rabatt verfügbar ist. Klicken Sie auf das hervorgehobene Datum, um sich die Details zum Rabatt anzusehen.",
  "gender_female": "Weiblich",
  "gender_male": "Männlich",
  "gender_none": "",
  "have_coupon_code": "Gutscheincode?",
  "insurance": "Versicherung",
  "invalid_voucher_code": "Ungültiger Gutscheincode",
  "loading": "Wird geladen…",
  "max_x_persons_one": "max {{ count }} Person",
  "max_x_persons_other": "max {{ count }} Personen",
  "next": "Weiter",
  "no_cabins_available": "Keine Kabinen verfügbar",
  "no_diet": "Keine Diät",
  "no_ship_available": "Kein Schiff verfügbar.",
  "number_of_products": "Anzahl der Produkte",
  "on_request": "Auf Anfrage",
  "on_request_tooltip": "\"Verfügbar auf Anfrage\" bedeutet, dass wir die Verfügbarkeit aus verschiedenen Gründen noch einmal prüfen müssen. Sie erhalten von uns innerhalb von 48 Stunden eine Buchungsbestätigung bzw. alternative Reisevorschläge.",
  "only_x_left_one": "Nur {{ count }} verbleibend",
  "only_x_left_other": "Nur {{ count }} verbleibend",
  "passenger": "Passagiere",
  "people_count": "{{ count }} Personen",
  "people_count_one": "{{ count }} Person",
  "personal_information_additional": "Persönliche Daten - Weiterer Passagier {{ index }}",
  "personal_information_main": "Persönliche Daten - Hauptbucher",
  "price": "Preis",
  "price_overview": "Preisübersicht",
  "price_per_person": "{{ price }} p.P.",
  "price_starting_from": "ab {{ price }}",
  "prices_and_availability": "Preise & Verfügbarkeit",
  "processing_payment": "Bearbeitung Zahlung",
  "product_name": "Produktbezeichnung",
  "read_less": "Weniger anzeigen",
  "read_more": "Mehr anzeigen",
  "remove_coupon_code": "Gutscheincode entfernen?",
  "search_for_a_tour": "Eine Reise suchen",
  "select_date": "Bitte wählen Sie ein Datum",
  "select_your_cabins": "Bitte wählen Sie Ihre Kabine(n) aus",
  "something_went_wrong": "Es ist ein Fehler aufgetreten",
  "start_booking": "Buchung starten",
  "subtotal": "Zwischensumme",
  "total": "Gesamt",
  "unavailable": "Ausgebucht",
  "unknown": "Unbekannt",
  "unsupported_browser_description": "Bitte aktualisieren Sie Ihren Browser.",
  "unsupported_browser_title": "Ihr Browser wird nicht unterstützt.",
  "vat": "MwSt ({{ percentage }}%)",
  "voucher_placeholder": "Gutscheincode",
  "x_days_one": "{{ count }} Tag",
  "x_days_other": "{{ count }} Tage"
}
